/**
 * An object defining different user roles within the application.
 *
 * @property {string} STUDENT - Represents a user who is a student.
 * @property {string} TEACHER - Represents a user who is a teacher.
 * @property {string} ADMIN - Represents a user who is an administrator.
 */
export const Roles = Object.freeze({
  STUDENT: "student",
  TEACHER: "teacher",
  ADMIN: "admin",
});
